module.exports = __webpack_public_path__ + "media/images/chevron-down-90e16c9b39b34736dd865146a3bd78bf.svg";